import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { PersonDto } from "../../../../dtos/catalogs/person/PersonDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { GenderTypeEnum } from "../../../../dtos/catalogs/person/CreatePersonDto";
import PersonDetailSkeleton from "./PersonDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import PersonDetailMain from "./PersonDetailMain";
import PersonDetailDocument from "./PersonDetailDocument";
import PersonDetailContracts from "./PersonDetailContracts";
import PersonDetailAdditional from "./PersonDetailAdditional";

interface IProps {
  model: PersonDto | null;
  modelUpdatedEvent: (newModel: PersonDto) => void;
}

interface PersonModel {
  id: string;
  name?: string;
  gender?: number;
  email?: string;
  isEmailValidPerson: boolean;
  phoneNumber?: string;
  actualAddress?: string;
  validToDate: Date;
  issuedDate: Date;
  issuedBy?: string;
  documentNumber?: string;
  documentSeries?: string;
  documentType?: string;
  citizenship?: string;
  addressOfBirth?: string;
  dateOfBirth: Date;
  tin?: string;
  uniqueCode?: string;
  photo?: string;
  lastName?: string;
  firstName?: string;
}

export const PersonDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const [baseImage, setBaseImage] = useState<any>("");

  const uploadImage = async (e: any) => {
    const file = e.target.files[0];
    const base64 = await convertBase64(file);
    setBaseImage(base64);
  };

  const convertBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<PersonModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("email", model.email);
      setValue("isEmailValidPerson", model.isEmailValidPerson);
      setValue("phoneNumber", model.phoneNumber);
      setValue("actualAddress", model.actualAddress);
      setValue("validToDate", model.validToDate);
      setValue("issuedDate", model.issuedDate);
      setValue("issuedBy", model.issuedBy);
      setValue("documentNumber", model.documentNumber);
      setValue("documentSeries", model.documentSeries);
      setValue("documentType", model.documentType);
      setValue("citizenship", model.citizenship);
      setValue("addressOfBirth", model.addressOfBirth);
      setValue("dateOfBirth", model.dateOfBirth);
      setValue("tin", model.tin);
      setValue("photo", model.photo);
      setValue("lastName", model.lastName);
      setValue("firstName", model.firstName);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: PersonModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: PersonDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <PersonDetailSkeleton />
      </>
    );
  }
  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
          <NFTab title={"Document"} />
          <NFTab title={"Contracts"} />
          <NFTab title={"Additional"} />
          <NFTab title={"Photo"} />
        </NFTabs>

        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <PersonDetailMain />
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <PersonDetailDocument />
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <PersonDetailContracts />
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <PersonDetailAdditional />
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <Col sm={6}>
            <input
              type="file"
              onChange={(e) => {
                uploadImage(e);
              }}
              className="form-control"
            />
            <br></br>
            {baseImage && <img src={baseImage} height="200px" />}
          </Col>
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
